(ns portal.delivery-page.view
  (:require [common.widgets.page :as page]
            [portal.delivery-table.view :as delivery-table]
            [uix.core :refer [defui $]]))

(defui delivery-page []
  ($ page/page
     ($ page/page-header {:title "Delivery Insights"})
     ($ page/content-padding
        {:sx #js {:overflow "hidden"}}
        ($ delivery-table/table))))
